<template>
  <div
    v-if="advancedFeature"
    class="my-4 flex items-center gap-2 rounded-lg border border-violet-200 bg-gradient-to-r from-sky-50/70 to-violet-50/70 px-2 py-3 text-xs text-gray-500"
    role="note"
  >
    <AdvancedFeatureBadge class="shrink-0" />
    <span>{{ description }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import AdvancedFeatureBadge from "./AdvancedFeatureBadge.vue";
import { useSystemStore } from "@/stores/system";
import { getAdvancedFeatureByApiUrl } from "@/lib/advanced-features";

const props = defineProps<{
  apiUrl: string;
}>();

const systemStore = useSystemStore();
const advancedFeature = computed(() =>
  getAdvancedFeatureByApiUrl(systemStore.advancedApiConfig, props.apiUrl)
);
const description = computed(() => advancedFeature.value?.advancedDesc || "");
</script>
